// extracted by mini-css-extract-plugin
export default {"rules__container":"styles_rules__container__FvicD","rules__text":"styles_rules__text__tknxV","rules__header":"styles_rules__header__BIuFs"};